import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import { StorageLocation } from '../types'

type MessageHistoryState = {
  messageHistory: string[]
}

type MessageHistoryActions = {
  addMessageToHistory: (message: string) => void
  clearHistory: () => void
}

type MessageHistoryStore = MessageHistoryState & MessageHistoryActions

const createMessageHistoryStore = (storeName: string, storageLocation?: StorageLocation) =>
  create<MessageHistoryStore>()(
    devtools(
      persist(
        (set) => ({
          messageHistory: [],
          addMessageToHistory: (message) =>
            set((state) => ({
              ...state,
              messageHistory: [message, ...(state.messageHistory ?? []).slice(0, 100).filter(String)],
            })),
          clearHistory: () =>
            set(() => ({
              messageHistory: [],
            })),
        }),
        {
          name: storeName,
          storage: createJSONStorage(() => (storageLocation === 'sessionStorage' ? sessionStorage : localStorage)),
        }
      )
    )
  )

type BoundMessageHistoryStore = ReturnType<typeof createMessageHistoryStore>

const messageHistoryStoreInstances: { [key: string]: BoundMessageHistoryStore } = {}

export const getUseMessageHistoryStore = (
  conversationId: string,
  storageKey?: string,
  storageLocation?: StorageLocation
): BoundMessageHistoryStore => {
  const baseKey = storageKey || 'bp-webchat'
  const storeKey = `${baseKey}-message-history-${conversationId}`

  if (!messageHistoryStoreInstances[storeKey]) {
    messageHistoryStoreInstances[storeKey] = createMessageHistoryStore(storeKey, storageLocation)
  }

  return messageHistoryStoreInstances[storeKey]
}
